import { Component, inject, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, RouterLink, } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { HeaderComponent } from '../../components/header/header.component';
import { GlobalService } from '../../services/global.service';
import { ButtonComponent } from '../../components/button/button.component';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { ModalComponent } from '../../components/modal/modal.component';
import { TextInputComponent } from '../../components/text-input/text-input.component';
import { PluralPipe } from '../../pipes/plural.pipe';
import { AgGridListComponent } from "../../components/ag-grid-list/ag-grid-list.component";
import { ListActionButtonsComponent } from '../../components/list-action-buttons/list-action-buttons.component';
import { SelectInputComponent } from '../../components/select-input/select-input.component';
import { DropdownService } from '../../services/dropdown.service';
import { UniversityService } from '../../services/university.service';
import { BulkUploadComponent } from '../../components/bulk-upload/bulk-upload.component';
import { SearchInputComponent } from '../../components/search-input/search-input.component';
import { DateInputComponent } from "../../components/date-input/date-input.component";
import { RadioInputComponent } from "../../components/radio-input/radio-input.component";
import { CheckboxComponent } from "../../components/checkbox/checkbox.component";
import { ImageUploderComponent } from "../../components/image-uploder/image-uploder.component";
import { AssessmentService } from '../../services/assessment.service';
import { FormSectionComponent } from '../../components/form-section/form-section.component';
import { FormService } from '../../services/form.service';


@Component({
  selector: 'app-assessment-page',
  imports: [HeaderComponent, ButtonComponent, CommonModule, FormsModule, ConfirmationPopupComponent, ModalComponent, ReactiveFormsModule, PluralPipe, AgGridListComponent, SearchInputComponent, BulkUploadComponent, RouterLink, SelectInputComponent],
  templateUrl: './assessment-page.component.html',
  styleUrl: './assessment-page.component.css'
})
export class AssessmentPageComponent {
  @ViewChild('confirmation_delete_modal') confirmation_delete_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('form_modal') form_modal: ModalComponent | undefined;
  @ViewChild('bulk_modal') bulk_modal: any
  fs = inject(FormService);
  page_name = 'Assessment';
  form: FormGroup;
  params: any = {};
  selected_ids: any = {}
  items: any = [];

  bulk_columns_download: any = [
    { column_name: 'Subject', type: 'text', download_bind: 'Subject.name', return_as: 'Subject.name' },
    { column_name: 'Subject Code', type: 'text', download_bind: 'Subject.code', return_as: 'Subject.code' },
    { column_name: 'Exam Code', type: 'text', download_bind: 'Exam.code', return_as: 'Exam.code' },
    { column_name: 'Exam Name', type: 'text', download_bind: 'Exam.name', return_as: 'Exam.name' },
    { column_name: 'Academic Year', type: 'text', download_bind: 'AcademicYear.name', return_as: 'AcademicYear.name' },
    { column_name: 'Evaluation Start Date', type: 'text', download_bind: 'evaluation_start_date', return_as: 'evaluation_start_date' },
    { column_name: 'Evaluation End Date', type: 'text', download_bind: 'evaluation_end_date', return_as: 'evaluation_end_date' },
  ];

  filter_academic_years: any[] = [];
  filter_exams: any[] = [];
  filter_subjects: any[] = [];
  filterDropdownRegistry: { [depended: number]: any } = {};

  assessment_cols: any = [
    // { valueGetter: (params: any) => `${params.data.evaluation_start_date} - ${params.data.evaluation_end_date}`, headerName: 'Date', minWidth: 160, flex: 1 },
    { headerName: 'Subject (Code)', filter: true, flex: 2, valueGetter: (p: any) => [p.data?.Subject.name, `(${p.data?.Subject.code})`].filter(Boolean).join(` `) },
    { field: 'Exam.code', headerName: 'Exam Code', minWidth: 130, flex: 1 },
    { field: 'Exam.name', headerName: 'Exam Name', minWidth: 150, flex: 1 },
    { field: 'AcademicYear.name', headerName: 'Academic Year', minWidth: 140, flex: 1 },
    { field: 'evaluation_start_date', headerName: 'Evaluation Start Date', minWidth: 180, flex: 1 },
    { field: 'evaluation_end_date', headerName: 'Evaluation End Date', minWidth: 180, flex: 1 },
    { field: 'qp_pattern', headerName: 'Question Paper Pattern', minWidth: 220, flex: 1, cellStyle: { 'display': 'flex', 'justify-content': 'center', 'align-items': 'center' }, cellRenderer: (params: any) => this.showFileLink(params, 'qp_pattern.csv') },
    { field: 'qp_file', headerName: 'Question Paper File', minWidth: 180, flex: 1, cellStyle: { 'display': 'flex', 'justify-content': 'center', 'align-items': 'center' }, cellRenderer: (params: any) => this.showFileLink(params, 'qp_file.pdf') },
    { field: 'soe_upload', headerName: 'SOE Upload', minWidth: 150, flex: 1, cellStyle: { 'display': 'flex', 'justify-content': 'center', 'align-items': 'center' }, cellRenderer: (params: any) => this.showFileLink(params, 'soe_upload.pdf') },
    { field: 'model_answer_sheet', headerName: 'Model Answer Sheet', minWidth: 180, flex: 1, cellStyle: { 'display': 'flex', 'justify-content': 'center', 'align-items': 'center' }, cellRenderer: (params: any) => this.showFileLink(params, 'model_answer_sheet.pdf') },
    { headerName: "", sortable: false, pinned: 'right', editable: false, width: 130, minWidth: 130, maxWidth: 130, cellRenderer: ListActionButtonsComponent, headerClass: 'custom-header-center', cellRendererParams: { actions: this.actions.bind(this) } }
  ];

  bulk_columns = [
    { column_name: 'Country Name', type: 'text', return_as: 'country_id', sample_value: 'India' },
    { column_name: 'State Name', type: 'text', return_as: 'state_id', sample_value: 'Maharashtra' },
    { column_name: 'City Name', type: 'text', return_as: 'city_id', sample_value: 'Mumbai Suburban' },
    { column_name: 'University Name', type: 'text', return_as: 'name', sample_value: 'Mumbai University' },
    { column_name: 'Address', type: 'text', return_as: 'address', sample_value: 'Vidya Nagari, Kalina, Santacruz East, Mumbai, Maharashtra 400098', min_length: 10, max_length: 250 },
    { column_name: 'Email id', type: 'text', return_as: 'email', sample_value: 'mumbai.university@gmail.com', strict_validation: 'email' },
    { column_name: 'Contact Number', type: 'text', return_as: 'contact', sample_value: '9829398274', strict_validation: 'mobile', min_length: 10, max_length: 10 },
    { column_name: 'Code', type: 'text', return_as: 'code', sample_value: 'MU' },
  ];
  actions(row: any) {
    let actions: any = []
    actions.push({ text: 'View', shortcut: 'v', color: 'green', icon: 'bx bx-show', function: this.view_modal_open.bind(this), })
    actions.push({ text: 'Edit', shortcut: 'u', color: 'sky', icon: 'bx bx-edit', function: this.open_form_modal.bind(this), permissions: this.gs.user_role_data?.evaluation_management_assessments_update })
    actions.push({ text: 'Delete', shortcut: 'd', color: 'red', icon: 'bx bx-trash', function: this.delete_modal_open.bind(this), permissions: this.gs.user_role_data?.evaluation_management_assessments_delete })
    return actions
  }
  constructor(public gs: GlobalService, public route: Router, public fb: FormBuilder, public as: AssessmentService, public ar: ActivatedRoute, public ds: DropdownService) {
    this.form = this.fb.group({
      exam_code: ['', [Validators.required]],
      exam_id: ['', [Validators.required]],
      academic_id: ['', [Validators.required]],
      university_id: ['', [Validators.required]],
      college_id: ['', [Validators.required]],
      level_id: ['', [Validators.required]],
      program_id: ['', [Validators.required]],
      stream_id: ['', [Validators.required]],
      subject_id: ['', [Validators.required]],
      total_marks: ['1', [Validators.required, Validators.min(1)]],
      passing_marks: ['1', [Validators.required, Validators.min(1)]],
      evaluation_start_date: ['', [Validators.required]],
      evaluation_end_date: ['', [Validators.required]],
      per_day_target_for_faculty: ['', [Validators.required]],
      grace_period: ['', [Validators.required]],
      minimum_time_per_answer_script: ['', [Validators.required]],
      annotations_required: ['', [Validators.required]],
      number_of_evaluations: ['', [Validators.required]],
      header_exminer_required: ['', [Validators.required]],
      persentage_of_script_he_to_check: ['', [Validators.required]],
      qp_pattern: ['', [Validators.required]],
      qp_file: ['',],
      seo_upload: ['',],
      model_answer_sheet: ['',],
    });
  }
  registerFilterDropdown(event: { depended: number; ref: any }) {
    this.filterDropdownRegistry[event.depended] = event.ref;
  }

  onFilterDropdownChange(event: { value: any, depended: number }) {
    if (event.depended == 1) {
      this.params.university_id = event.value?.value || null;
      this.params.academic_year_id = null;
      this.params.exam_id = null;
      this.params.subject_id = null;
    }
    if (event.depended == 2) {
      this.params.academic_year_id = event.value?.value || null;
      this.params.exam_id = null;
      this.params.subject_id = null;
    }
    if (event.depended == 3) {
      this.params.exam_id = event.value?.value || null;
      this.params.subject_id = null;
    }
    if (event.depended == 4) {
      this.params.subject_id = event.value?.value || null;
    }
    this.update_list_filtered_options();
    for (const key of Object.keys(this.filterDropdownRegistry).map(Number)) {
      if (key > event.depended) this.filterDropdownRegistry[key]?.reset();
    }
    this.get_list(this.params);
  }

  // Pre-select the filters to the most recent assessment so the list opens on the data the user
  // actually works with. Must run after apply_access_scope_to_params(): a locked filter is never
  // overwritten, and the "latest" row is picked from within the user's scope only.
  patch_latest_assessment() {
    const all: any[] = this.ds.dropdown_list?.assessment_list || [];
    if (!all.length) return;
    const locked = this.gs.access_scope.locked;
    const in_scope = all.filter((a: any) =>
      (!locked.university || a.university_id == this.params.university_id) &&
      (!locked.subject || a.subject_id == this.params.subject_id)
    );
    if (!in_scope.length) return;
    const latest = in_scope.reduce((prev: any, curr: any) => (curr.id > prev.id ? curr : prev));
    if (!locked.university) this.params.university_id = latest.university_id || null;
    this.params.academic_year_id = latest.academic_year_id || null;
    this.params.exam_id = (latest.exam_id && latest.exam_id !== 'none') ? latest.exam_id : null;
    if (!locked.subject) this.params.subject_id = latest.subject_id || null;
  }

  update_list_filtered_options() {
    const list = this.ds.dropdown_list;
    const has_uni = !!this.params.university_id;
    const has_ay = !!this.params.academic_year_id;
    const has_exam = !!this.params.exam_id;

    if (!has_uni || !list?.assessment_list) {
      this.filter_academic_years = [];
    } else {
      const ids = [...new Set(list.assessment_list.filter((a: any) => a.university_id == this.params.university_id).map((a: any) => a.academic_year_id))];
      this.filter_academic_years = list?.academic_list?.filter((a: any) => ids.includes(a.id)) || [];
    }

    if (!has_uni) {
      this.filter_exams = [];
    } else {
      this.filter_exams = list?.exam_name_and_code_list?.filter((e: any) => e.university_id == this.params.university_id) || [];
    }

    if (!has_uni) {
      this.filter_subjects = [];
    } else {
      this.filter_subjects = (list?.subject_list || [])
        .filter((s: any) => s.university_id == this.params.university_id)
        .map((s: any) => ({ title: s.name || s.title, value: s.id || s.value }));
    }
  }

  async ngOnInit() {
    // Access Level: lock the filters this user cannot change before the first fetch.
    this.gs.apply_access_scope_to_params(this.params);
    await this.ds?.get_dropdown_list(['university', 'program', 'stream', 'course', 'subject', 'academic-year', 'college', 'exam', 'level', 'assessment']);
    // patch_latest_assessment() existed but was never called, so this page always opened with the
    // four filters blank while Barcode Mapping / Scripts opened pre-filled.
    this.patch_latest_assessment();
    this.update_list_filtered_options();
    setTimeout(() => {
      this.filterDropdownRegistry[1]?.writeValue(this.params.university_id);
      this.filterDropdownRegistry[2]?.writeValue(this.params.academic_year_id);
      this.filterDropdownRegistry[3]?.writeValue(this.params.exam_id);
      this.filterDropdownRegistry[4]?.writeValue(this.params.subject_id);
    });
    await this.get_list(this.params);
  }

  async get_list(filter?: any) {
    try {
      const res = await this.as.get_list({ ...this.params, ...filter });
      const page = filter?.page || 1;
      const pagesize = filter?.page_size || 10;
      const startindex = (page - 1) * pagesize;

      res.data = res.data.map((item: any, index: number) => ({
        ...item,
        SrNo: startindex + index + 1
      }));

      this.items = res;
    } catch (error: any) {
      console.error("Error fetching Booking list:", error);
    }
  }
  open_script_page() {
    this.route.navigate(['/script/list']);
  }
  open_add_script_page() {
    this.route.navigate(['/add-script/list']);
  }
  async delete_modal_open(item: any, index: any) {
    this.selected_ids = item;
    this.confirmation_delete_modal?.open();
  }
  async view_modal_open(item: any, index: any) {
    const id = item?.id || null;
    if (id) {
      this.route.navigate(['/assessment/form'], {
        queryParams: { id: id, action: 'view' },
        queryParamsHandling: 'merge',
      });
      // this.route.navigate(['/assessment/form', {id:id}]);
    }
  }
  async delete_university() {
    try {
      let res = await this.as.delete(this.selected_ids.id);
      if (res != undefined) {
        this.gs.toastr_shows_function(res.message, 'Success', 'success');
      }
      this.selected_ids = {};
      this.confirmation_delete_modal?.close()
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  download() {
    if (this.items?.count > 0) {
      this.fs.bulk_download(this.as, 'get_list', this.bulk_columns_download, 'Assessment', this.params);
    }
  }

  async bulk_delete(ids: any[]) {
    try {
      let res: any
      for (let id of ids) {
        res = await this.as.delete(id);
      }
      this.gs.toastr_shows_function(res?.message, 'Success', 'success');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  view_scripts(item: any) { }
  async open_form_modal(item?: any) {
    const id = item?.id || null;
    if (id) {
      this.route.navigate(['/assessment/form'], {
        queryParams: { id: id },
        queryParamsHandling: 'merge',
      });
      // this.route.navigate(['/assessment/form', {id:id}]);
    }
  }
  close_form_modal(): void {
    this.form_modal?.close();
  }
  async submit() {
    try {
      if (this.form.invalid) {
        this.gs.toastr_shows_function('Please fill all required fields correctly.', 'Error', 'error');
        this.form.markAllAsTouched();
        return;
      }
      let form_value = this.form.value;
      if (this.selected_ids && this.selected_ids.id) {
        let update_response = await this.as.update(this.selected_ids.id, form_value);
        this.gs.toastr_shows_function('Changes updated successfully', 'Success', 'success');
      } else {
        let create_response = await this.as.add(form_value);
        this.gs.toastr_shows_function(create_response?.message, 'Success', 'success');
      }
      await this.get_list(this.params);
      this.close_form_modal();
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  async bulk_upload(data: any, spinner: any) {
    try {
      await this.gs.bulk_form_submission(data, this.as, this.params, this.get_list.bind(this), this.bulk_modal, spinner)
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }

  showFileLink(params: any, defaultFileName?: string) {
    if (!params.value) return '-';

    let fileType = '';
    let downloadAttr = '';
    let href = params.value;

    if (params.value.startsWith('data:text/csv')) {
      fileType = 'CSV';
      downloadAttr = `download="${defaultFileName || 'file.csv'}"`;
    } else if (params.value.startsWith('data:application/pdf')) {
      fileType = 'PDF';
      downloadAttr = '';

      const byteString = atob(params.value.split(',')[1]);
      const mimeString = params.value.split(',')[0].split(':')[1].split(';')[0];
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([ab], { type: mimeString });
      href = URL.createObjectURL(blob);
    } else {
      fileType = 'File';
    }

    return `
    <a href="${href}" target="_blank" ${downloadAttr} style="display:inline-flex; align-items:center; justify-content:center;">
      <img src="assets/document-download.png" alt="View File" style="width:24px; height:24px;" />
    </a>
  `;
  }






}
